import React from "react";

// Página pública (sin login ni layout): Política de Privacidad de CentralSaludApp.
// Se enlaza como URL desde App Store Connect (Apple exige una URL de privacidad).

const C = { verde: "#3cbf9a", verdeOscuro: "#2da080", tinta: "#1f2933", gris: "#5b6770", borde: "#e6eaee" };

const S = {
  body: { margin: 0, background: "#f3f5f7", color: C.tinta, fontFamily: '-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,Helvetica,Arial,sans-serif', lineHeight: 1.6, minHeight: "100vh" },
  wrap: { maxWidth: 820, margin: "0 auto", padding: "0 0 64px" },
  header: { background: C.verde, color: "#fff", padding: "36px 28px" },
  brand: { fontSize: 22, fontWeight: 700 },
  sub: { fontSize: 14, color: "#e3f6ef", marginTop: 4 },
  bar: { height: 4, background: C.verdeOscuro },
  main: { background: "#fff", padding: "36px 28px" },
  h1: { fontSize: 24, margin: "0 0 4px" },
  updated: { color: C.gris, fontSize: 13, margin: "0 0 28px" },
  h2: { fontSize: 17, margin: "30px 0 8px", color: C.verdeOscuro },
  p: { fontSize: 15, color: C.tinta },
  ul: { paddingLeft: 20, fontSize: 15 },
  a: { color: C.verdeOscuro },
  card: { border: `1px solid ${C.borde}`, borderLeft: `4px solid ${C.verde}`, borderRadius: 8, padding: "14px 18px", margin: "16px 0", background: "#fbfdfc" },
  footer: { textAlign: "center", color: C.gris, fontSize: 13, padding: 24 },
};

export default function PrivacidadApp() {
  return (
    <div style={S.body}>
      <div style={S.wrap}>
        <header style={S.header}>
          <div style={S.brand}>CentralSalud</div>
          <div style={S.sub}>Política de Privacidad de la aplicación</div>
        </header>
        <div style={S.bar} />
        <main style={S.main}>
          <h1 style={S.h1}>Política de Privacidad</h1>
          <p style={S.updated}>Última actualización: junio de 2026</p>

          <p style={S.p}>Esta Política de Privacidad describe cómo la aplicación <strong>CentralSalud</strong> (en adelante, “la App”) trata la información de las personas que la utilizan. La App es una herramienta profesional de gestión de pedidos e inventario dirigida a clínicas y centros y a su personal autorizado.</p>

          <h2 style={S.h2}>1. Responsable del tratamiento</h2>
          <p style={S.p}>El responsable del tratamiento de los datos es CentralSalud. Para cualquier cuestión relacionada con la privacidad puede contactar en <a style={S.a} href="mailto:soporte@centralsalud.es">soporte@centralsalud.es</a>.</p>

          <h2 style={S.h2}>2. Datos que tratamos</h2>
          <ul style={S.ul}>
            <li><strong>Datos de cuenta y acceso:</strong> nombre de usuario, identificador y credenciales necesarias para iniciar sesión. La sesión se guarda de forma local en el dispositivo para mantenerle conectado.</li>
            <li><strong>Datos de actividad profesional:</strong> pedidos, productos, niveles de stock, lotes, movimientos de inventario y la clínica/centro asociado a su cuenta, generados al usar la App.</li>
            <li><strong>Documentos que usted aporta:</strong> archivos (por ejemplo, hojas de cálculo o facturas) que usted selecciona voluntariamente para subir a través de la App.</li>
            <li><strong>Datos técnicos mínimos:</strong> información necesaria para el correcto funcionamiento y la seguridad del servicio.</li>
          </ul>
          <p style={S.p}>La App <strong>no recopila</strong> datos de salud de pacientes, ni datos de localización, ni utiliza los datos con fines publicitarios.</p>

          <h2 style={S.h2}>3. Permisos del dispositivo</h2>
          <div style={S.card}>
            <p style={{ ...S.p, margin: "0 0 8px" }}><strong>Cámara:</strong> se utiliza únicamente para escanear códigos de barras de productos durante las tareas de inventario. Las imágenes <strong>no se almacenan</strong> ni se envían a nuestros servidores; el escaneo se procesa en el momento.</p>
            <p style={{ ...S.p, margin: 0 }}><strong>Acceso a archivos / documentos:</strong> se utiliza solo cuando usted elige un archivo para subirlo. La App no accede a su galería ni a otros archivos sin su acción explícita.</p>
          </div>

          <h2 style={S.h2}>4. Finalidad y base legal</h2>
          <p style={S.p}>Tratamos los datos para prestar el servicio de gestión de pedidos e inventario, autenticar su acceso, procesar las operaciones que usted realiza y garantizar la seguridad del sistema. La base legal es la ejecución del servicio solicitado y nuestro interés legítimo en operar y proteger la plataforma.</p>

          <h2 style={S.h2}>5. Conservación</h2>
          <p style={S.p}>Conservamos los datos mientras su cuenta esté activa y durante el tiempo necesario para cumplir las obligaciones legales y operativas. Cuando dejan de ser necesarios, se eliminan o anonimizan.</p>

          <h2 style={S.h2}>6. Compartición de datos</h2>
          <p style={S.p}>No vendemos sus datos. Solo se comparten con los proveedores estrictamente necesarios para procesar sus pedidos y con los proveedores tecnológicos que alojan y dan soporte al servicio, siempre bajo las garantías adecuadas. También podremos comunicarlos cuando lo exija la ley.</p>

          <h2 style={S.h2}>7. Seguridad</h2>
          <p style={S.p}>Aplicamos medidas técnicas y organizativas razonables para proteger la información frente a accesos no autorizados, pérdida o alteración, incluyendo el cifrado de las comunicaciones.</p>

          <h2 style={S.h2}>8. Sus derechos</h2>
          <p style={S.p}>Usted puede ejercer sus derechos de acceso, rectificación, supresión, limitación, oposición y portabilidad de sus datos escribiendo a <a style={S.a} href="mailto:soporte@centralsalud.es">soporte@centralsalud.es</a>. También puede solicitar la eliminación de su cuenta.</p>

          <h2 style={S.h2}>9. Menores</h2>
          <p style={S.p}>La App está dirigida a personal profesional y no está destinada a menores de edad. No recopilamos conscientemente datos de menores.</p>

          <h2 style={S.h2}>10. Cambios en esta política</h2>
          <p style={S.p}>Podremos actualizar esta Política de Privacidad. Publicaremos cualquier cambio en esta misma página, indicando la fecha de última actualización.</p>

          <h2 style={S.h2}>11. Contacto</h2>
          <p style={S.p}>Para cualquier duda sobre esta política o sobre el tratamiento de sus datos: <a style={S.a} href="mailto:soporte@centralsalud.es">soporte@centralsalud.es</a>.</p>
        </main>
        <footer style={S.footer}>
          © CentralSalud · <a style={S.a} href="https://www.centralsalud.es">www.centralsalud.es</a>
        </footer>
      </div>
    </div>
  );
}
